import * as Job$SolvuuApi0 from "solvuu-api0/./job.bs.js";
import * as Job_bs$SolvuuApi0 from "solvuu-api0/./job_bs.bs.js";
import * as Job_event_bs$SolvuuApi0 from "solvuu-api0/./job_event_bs.bs.js";
import * as Job_event_atd$SolvuuApi0 from "solvuu-api0/./job_event_atd.bs.js";
import * as Job_events_bs$SolvuuApi0 from "solvuu-api0/./job_events_bs.bs.js";
import * as Job_events_atd$SolvuuApi0 from "solvuu-api0/./job_events_atd.bs.js";
import * as Job_create_request_bs$SolvuuApi0 from "solvuu-api0/./job_create_request_bs.bs.js";
import * as Job_create_response_bs$SolvuuApi0 from "solvuu-api0/./job_create_response_bs.bs.js";
import * as Job_create_response_atd$SolvuuApi0 from "solvuu-api0/./job_create_response_atd.bs.js";
import * as Job_get_by_id_request_bs$SolvuuApi0 from "solvuu-api0/./job_get_by_id_request_bs.bs.js";
import * as Job_get_by_id_response_bs$SolvuuApi0 from "solvuu-api0/./job_get_by_id_response_bs.bs.js";
import * as Job_get_events_request_bs$SolvuuApi0 from "solvuu-api0/./job_get_events_request_bs.bs.js";
import * as Job_get_by_id_response_atd$SolvuuApi0 from "solvuu-api0/./job_get_by_id_response_atd.bs.js";
import * as Job_get_events_response_bs$SolvuuApi0 from "solvuu-api0/./job_get_events_response_bs.bs.js";
import * as Job_get_events_response_atd$SolvuuApi0 from "solvuu-api0/./job_get_events_response_atd.bs.js";
var Json = Job_bs$SolvuuApi0;
var json_of_job_id = Job$SolvuuApi0.json_of_job_id;
var json_of_blob_id = Job$SolvuuApi0.json_of_blob_id;
var json_of_spec = Job$SolvuuApi0.json_of_spec;
var json_of_status = Job$SolvuuApi0.json_of_status;
var json_of_backend = Job$SolvuuApi0.json_of_backend;
var json_of_output = Job$SolvuuApi0.json_of_output;
var json_of_t = Job$SolvuuApi0.json_of_t;
var job_id_of_json = Job$SolvuuApi0.job_id_of_json;
var blob_id_of_json = Job$SolvuuApi0.blob_id_of_json;
var spec_of_json = Job$SolvuuApi0.spec_of_json;
var status_of_json = Job$SolvuuApi0.status_of_json;
var backend_of_json = Job$SolvuuApi0.backend_of_json;
var output_of_json = Job$SolvuuApi0.output_of_json;
var t_of_json = Job$SolvuuApi0.t_of_json;
var Solvuu = Job$SolvuuApi0.Solvuu;
var $$Event = {
  Json: Job_event_bs$SolvuuApi0,
  json_of_event: Job_event_atd$SolvuuApi0.json_of_event,
  json_of_solvuu_job_spec: Job_event_atd$SolvuuApi0.json_of_solvuu_job_spec,
  json_of_spec: Job_event_atd$SolvuuApi0.json_of_spec,
  json_of_create: Job_event_atd$SolvuuApi0.json_of_create,
  json_of_validate: Job_event_atd$SolvuuApi0.json_of_validate,
  json_of_submit: Job_event_atd$SolvuuApi0.json_of_submit,
  json_of_backend_status: Job_event_atd$SolvuuApi0.json_of_backend_status,
  json_of_status_update: Job_event_atd$SolvuuApi0.json_of_status_update,
  json_of_info: Job_event_atd$SolvuuApi0.json_of_info,
  json_of_t: Job_event_atd$SolvuuApi0.json_of_t,
  event_of_json: Job_event_atd$SolvuuApi0.event_of_json,
  solvuu_job_spec_of_json: Job_event_atd$SolvuuApi0.solvuu_job_spec_of_json,
  spec_of_json: Job_event_atd$SolvuuApi0.spec_of_json,
  create_of_json: Job_event_atd$SolvuuApi0.create_of_json,
  validate_of_json: Job_event_atd$SolvuuApi0.validate_of_json,
  submit_of_json: Job_event_atd$SolvuuApi0.submit_of_json,
  backend_status_of_json: Job_event_atd$SolvuuApi0.backend_status_of_json,
  status_update_of_json: Job_event_atd$SolvuuApi0.status_update_of_json,
  info_of_json: Job_event_atd$SolvuuApi0.info_of_json,
  t_of_json: Job_event_atd$SolvuuApi0.t_of_json
};
var Events = {
  Json: Job_events_bs$SolvuuApi0,
  json_of_event: Job_events_atd$SolvuuApi0.json_of_event,
  json_of_t: Job_events_atd$SolvuuApi0.json_of_t,
  event_of_json: Job_events_atd$SolvuuApi0.event_of_json,
  t_of_json: Job_events_atd$SolvuuApi0.t_of_json
};
var id = Job$SolvuuApi0.id;
var spec = Job$SolvuuApi0.spec;
var status = Job$SolvuuApi0.status;
var backend = Job$SolvuuApi0.backend;
var output = Job$SolvuuApi0.output;
var is_complete = Job$SolvuuApi0.is_complete;
var entity = Job$SolvuuApi0.entity;
var $$let = Job$SolvuuApi0.Get_by_id.$$Request;
var Get_by_id_service = Job$SolvuuApi0.Get_by_id.service;
var Get_by_id_entity = Job$SolvuuApi0.Get_by_id.entity;
var Get_by_id_Request = {
  Json: Job_get_by_id_request_bs$SolvuuApi0,
  json_of_info: $$let.json_of_info,
  info_of_json: $$let.info_of_json,
  path: $$let.path,
  body: $$let.body,
  info: $$let.info
};
var Get_by_id_Response = {
  Json: Job_get_by_id_response_bs$SolvuuApi0,
  json_of_ok: Job_get_by_id_response_atd$SolvuuApi0.json_of_ok,
  json_of_bad_request: Job_get_by_id_response_atd$SolvuuApi0.json_of_bad_request,
  json_of_not_found: Job_get_by_id_response_atd$SolvuuApi0.json_of_not_found,
  ok_of_json: Job_get_by_id_response_atd$SolvuuApi0.ok_of_json,
  bad_request_of_json: Job_get_by_id_response_atd$SolvuuApi0.bad_request_of_json,
  not_found_of_json: Job_get_by_id_response_atd$SolvuuApi0.not_found_of_json
};
var Get_by_id = {
  service: Get_by_id_service,
  entity: Get_by_id_entity,
  $$Request: Get_by_id_Request,
  $$Response: Get_by_id_Response
};
var Get_all = Job$SolvuuApi0.Get_all;
var $$let$1 = Job$SolvuuApi0.Create.$$Request;
var Create_entity = Job$SolvuuApi0.Create.entity;
var Create_service = Job$SolvuuApi0.Create.service;
var Create_Request = {
  Json: Job_create_request_bs$SolvuuApi0,
  json_of_info: $$let$1.json_of_info,
  info_of_json: $$let$1.info_of_json,
  path: $$let$1.path,
  body: $$let$1.body,
  info: $$let$1.info
};
var Create_Response = {
  Json: Job_create_response_bs$SolvuuApi0,
  json_of_ok: Job_create_response_atd$SolvuuApi0.json_of_ok,
  json_of_bad_request: Job_create_response_atd$SolvuuApi0.json_of_bad_request,
  json_of_not_found: Job_create_response_atd$SolvuuApi0.json_of_not_found,
  ok_of_json: Job_create_response_atd$SolvuuApi0.ok_of_json,
  bad_request_of_json: Job_create_response_atd$SolvuuApi0.bad_request_of_json,
  not_found_of_json: Job_create_response_atd$SolvuuApi0.not_found_of_json
};
var Create = {
  entity: Create_entity,
  service: Create_service,
  $$Request: Create_Request,
  $$Response: Create_Response
};
var $$let$2 = Job$SolvuuApi0.Get_events.$$Request;
var Get_events_entity = Job$SolvuuApi0.Get_events.entity;
var Get_events_service = Job$SolvuuApi0.Get_events.service;
var Get_events_Request = {
  Json: Job_get_events_request_bs$SolvuuApi0,
  json_of_info: $$let$2.json_of_info,
  info_of_json: $$let$2.info_of_json,
  path: $$let$2.path,
  body: $$let$2.body,
  info: $$let$2.info
};
var Get_events_Response = {
  Json: Job_get_events_response_bs$SolvuuApi0,
  json_of_ok: Job_get_events_response_atd$SolvuuApi0.json_of_ok,
  json_of_bad_request: Job_get_events_response_atd$SolvuuApi0.json_of_bad_request,
  json_of_not_found: Job_get_events_response_atd$SolvuuApi0.json_of_not_found,
  ok_of_json: Job_get_events_response_atd$SolvuuApi0.ok_of_json,
  bad_request_of_json: Job_get_events_response_atd$SolvuuApi0.bad_request_of_json,
  not_found_of_json: Job_get_events_response_atd$SolvuuApi0.not_found_of_json
};
var Get_events = {
  entity: Get_events_entity,
  service: Get_events_service,
  $$Request: Get_events_Request,
  $$Response: Get_events_Response
};
export { Json, json_of_job_id, json_of_blob_id, json_of_spec, json_of_status, json_of_backend, json_of_output, json_of_t, job_id_of_json, blob_id_of_json, spec_of_json, status_of_json, backend_of_json, output_of_json, t_of_json, Solvuu, $$Event, Events, id, spec, status, backend, output, is_complete, entity, Get_by_id, Get_all, Create, Get_events };
/* Job-SolvuuApi0 Not a pure module */